'use client';

import { c as _c } from "react/compiler-runtime";
import Modal from '@/components/atoms/Modal';
import { Crosshair } from '@/components/atoms/Icons';

/**
 * Modal displayed when user's location is outside the KC region.
 * Informs users that the app only shows Kansas City area content.
 */
export function LocationOutOfRegionModal(t0) {
  const $ = _c(4);
  const {
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pt-4 text-center"><div className="flex justify-center mb-4"><Crosshair className="h-8 w-8" /></div><h2 className="text-xl lg:text-[26px] font-semibold text-[#323232] mb-4 max-w-[205px] mx-auto leading-[1.07]">Outside Kansas City Area</h2><p className="text-[#626262] mb-6 text-base">Your location is outside the Kansas City region. Parade of Hearts only displays content and attractions within the Kansas City metro area.</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isOpen || $[2] !== onClose) {
    t2 = <Modal isOpen={isOpen} onClose={onClose} ariaLabel="Location outside Kansas City region" className="md:max-w-md max-w-full">{t1}</Modal>;
    $[1] = isOpen;
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}